import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';
import { UserAvatar } from 'components/shared/User';
import TextBody from './TextBody';
import TextBodyWithHyperlinks from './TextBodyWithHyperlinks';
import ImageBody from './ImageBody';
import {
  chatContainerStyles,
  messageContainerStyles,
  avatarContainerStyles,
  avatarSpacerStyles,
} from './styles';
import { sharedAvatarStyles } from '../../../pages/admin/EstheticianMessaging/styles';
import { useMessageContent } from './hooks/useMessageContent';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { Avatar } from '@mui/material';
import { PhoneIphone } from '@mui/icons-material';

const Message = ({ message, isOutgoing, emitImageLoaded }) => {
  const { imageSrc, imageFileType, textWithHyperlinks, cleanBody } =
    useMessageContent({
      message,
    });

  const isTextParticipant = isValidPhoneNumber(message.author, 'US');

  return (
    <Box sx={chatContainerStyles(message.isLastMessageInParticipantBatch)}>
      <Box sx={messageContainerStyles(isOutgoing)}>
        <Choose>
          {/* When we want to display the avatar and have the user */}
          <When
            condition={
              message.isFirstMessageInParticipantBatch && !isTextParticipant
            }
          >
            <Box sx={avatarContainerStyles(isOutgoing)}>
              <UserAvatar sx={sharedAvatarStyles} userId={message.author} />
            </Box>
          </When>
          {/* When we want to display the avatar and don't have the user, show a phone icon */}
          <When condition={message.isFirstMessageInParticipantBatch}>
            <Box sx={avatarContainerStyles(isOutgoing)}>
              <Avatar sx={sharedAvatarStyles}>
                <PhoneIphone />
              </Avatar>
            </Box>
          </When>

          <Otherwise>
            <Box sx={avatarSpacerStyles} />
          </Otherwise>
        </Choose>

        <If condition={message.body && !textWithHyperlinks}>
          <TextBody
            message={message}
            isOutgoing={isOutgoing}
            cleanBody={cleanBody}
          />
        </If>

        <If condition={message.body && textWithHyperlinks}>
          <TextBodyWithHyperlinks
            message={message}
            tokens={textWithHyperlinks}
            isOutgoing={isOutgoing}
          />
        </If>

        <If condition={imageSrc}>
          <ImageBody
            message={message}
            src={imageSrc}
            fileType={imageFileType}
            isOutgoing={isOutgoing}
            emitImageLoaded={emitImageLoaded}
          />
        </If>
      </Box>
    </Box>
  );
};

Message.propTypes = {
  message: PropTypes.object.isRequired,
  isOutgoing: PropTypes.bool.isRequired,
  emitImageLoaded: PropTypes.func.isRequired,
};

export default Message;
